// extracted by mini-css-extract-plugin
export default {"icon--medium":"icon_icon--medium__OfpOm","icon--small":"icon_icon--small__ExT67"};